import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import EstimateForm from "./pages/EstimateForm";
import Result from "./pages/Result";
import CustomResult from "./pages/CustomResult";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import DatabaseImport from "./pages/DatabaseImport";
import Contracts from "./pages/Contracts";
import ContractForm from "./pages/ContractForm";
import DocumentStyles from "./pages/DocumentStyles";
import CRM from "./pages/CRM";
import Campaigns from "./pages/Campaigns";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import BlogAdmin from "./pages/BlogAdmin";
import AppSettings from "./pages/AppSettings";
import LegalSettings from "./pages/LegalSettings";
import LegalPage from "./pages/LegalPage";
import DataDeletion from "./pages/DataDeletion";
import MediaLibrary from "./pages/MediaLibrary";
import Pipeline from "./pages/Pipeline";
import Dashboard from "./pages/Dashboard";
import TodayTasks from "./pages/TodayTasks";
import AppointmentsManagement from "./pages/AppointmentsManagement";
import ActivityLog from "./pages/ActivityLog";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/estimate" element={<EstimateForm />} />
          <Route path="/result/:id" element={<Result />} />
          <Route path="/custom-result/:id" element={<CustomResult />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/import-db" element={<DatabaseImport />} />
          <Route path="/admin/contracts" element={<Contracts />} />
          <Route path="/admin/contracts/create" element={<ContractForm />} />
          <Route path="/admin/document-styles" element={<DocumentStyles />} />
          <Route path="/admin/crm" element={<CRM />} />
          <Route path="/admin/campaigns" element={<Campaigns />} />
          <Route path="/admin/blog" element={<BlogAdmin />} />
          <Route path="/admin/app-settings" element={<AppSettings />} />
          <Route path="/admin/legal-settings" element={<LegalSettings />} />
          <Route path="/admin/media-library" element={<MediaLibrary />} />
          <Route path="/admin/pipeline" element={<Pipeline />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/today" element={<TodayTasks />} />
          <Route path="/admin/appointments" element={<AppointmentsManagement />} />
          <Route path="/admin/activity-log" element={<ActivityLog />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/legal/:pageType" element={<LegalPage />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
